import { useAuth } from "../context/AuthContext";

const Permiso = ({ permiso, negacion, children }) => {
  const { usuario } = useAuth();

  const tienePermisoBase = usuario?.permisos?.includes(permiso);

  const tienePermisoBloqueante = negacion ? usuario?.permisos?.includes(negacion) : false;

  if (!tienePermisoBase || tienePermisoBloqueante) {
    return null;
  }

  return children;
};

export default Permiso;